'use strict';

var _ = require('lodash');
var SystemStatusHistoryTransformerFactory = function SystemStatusHistoryTransformerFactory(momentService, DataTransformer, FieldNameTranslationService, UserProcessingTransformationService) {
  var CLEARED = 'CLEARED';
  var percentageValueFields = ['boardingRate', 'cancellationRate', 'overbookingPercentageModel', 'groupMaterializationRate', 'regularAggregateShare', 'mappedAggregateShare'];
  var segmentLimitTypes = ['BOTH', 'LOCAL', 'CONNECTING'];
  function SystemStatusHistoryTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'status-history-mode';
    this.targetType = ['system-status-history-market', 'system-status-history-service', 'system-status-history-flight', 'system-status-history-fares'];
    this.priority = 1;
  }
  SystemStatusHistoryTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusHistoryTransformer.constructor = SystemStatusHistoryTransformer;
  SystemStatusHistoryTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  SystemStatusHistoryTransformer.prototype.isCacheable = function () {
    return true;
  };
  SystemStatusHistoryTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType.join('-');
  };
  function isPercentageValueFields(fieldName) {
    return percentageValueFields.indexOf(fieldName) !== -1;
  }
  function formatNumber(value) {
    if (_.isNaN(parseFloat(value))) {
      return value;
    }
    return parseFloat(parseFloat(value).toFixed(2));
  }
  function transformPercentageValue(value, fieldName) {
    if (value === CLEARED) {
      return CLEARED;
    }
    return isPercentageValueFields(fieldName) ? formatNumber(value * 100) : formatNumber(value);
  }
  function formatValue(field) {
    var value = transformPercentageValue(field.value, field.fieldName);
    if (field.fieldName !== 'segmentLimitType') {
      return field.valueType === 'O' ? value : value + (value === CLEARED ? '' : field.valueType);
    } else {
      return segmentLimitTypes[parseInt(value)];
    }
  }
  function formatPosName(posName) {
    if (_.isNil(posName)) {
      posName = 'Default';
    }
    return posName;
  }
  SystemStatusHistoryTransformer.prototype.transform = function (data) {
    var result = [];
    if (data && data.domain && data.domain.results) {
      var adjustmentHistory = data.domain.results;
      for (var i = 0, length = adjustmentHistory.length; i < length; i++) {
        var entry = adjustmentHistory[i];
        var departureDate = momentService.of(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var start = momentService.of(entry.begin, momentService.FIELD.FARES_USAGE_DATE);
        var end = momentService.of(entry.end, momentService.FIELD.FARES_USAGE_DATE);
        var adjustmentDate = momentService.of(entry.adjustmentDateTime, momentService.FIELD.ADJUSTMENTS_HISTORY_DATE_TIME);
        var valueWithSuffix = formatValue(entry);
        var newEntry = {
          departureDate: departureDate,
          start: start,
          end: end,
          market: entry.origin + '-' + entry.destination,
          classGroup: entry.classGroup,
          airline: entry.carrier,
          flight: entry.flightNumber,
          leg: entry.origin + '-' + entry.destination,
          cabin: entry.cabin ? entry.cabin : '-',
          className: entry.className ? entry.className : '-',
          route: entry.route,
          value: valueWithSuffix,
          field: FieldNameTranslationService.nameToLabel(entry.fieldName),
          changedBy: UserProcessingTransformationService.getUserDisplayName(entry.appliedBy),
          appliedByRuleId: entry.appliedByRuleId,
          faresSPOS: entry.faresSPOS,
          posName: formatPosName(entry.posName),
          changedOn: adjustmentDate,
          cleared: entry.value === CLEARED ? 1 : 0
        };
        result.push(newEntry);
      }
    }
    return result;
  };
  return SystemStatusHistoryTransformer;
};
SystemStatusHistoryTransformerFactory.$inject = ['MomentService', 'DataTransformerFactory', 'FieldNameTranslationService', 'UserProcessingTransformationService'];
module.exports = SystemStatusHistoryTransformerFactory;